export const OWNER_DOMAIN_KEY = 'owner';
